import { LiveEventService } from '../services/event.service'
import { ListenerDictionary } from '../components/video-player/video-player.events'
import { take } from 'rxjs/operators'
import { noop } from '../../shared/functions/noop'
import { AuthenticatedStreamResponse } from '@flocasts/flosports30-types/dist/live-api'
import { LoggingService } from 'src/app/singleton-services/logging/logging.service'

const handleError = (ls: LoggingService) => (err: any) => ls.error(err)

export const liveTeardownFactory = (
  es: LiveEventService,
  ls: LoggingService
): ListenerDictionary<AuthenticatedStreamResponse> => {
  return {
    suspend: (_event, _videoElement, _videoInstanceId, _videoGroupId, hlsLoaderMeta, _meta, _emitErrorFn) => {
      es.destroyStreamToken(hlsLoaderMeta.token.id).pipe(take(1)).subscribe(noop, handleError(ls))
    }
  }
}
